export default __webpack_public_path__ + "static/media/criminal3.d623ce8d.jpg";